import * as React from "react";
import reservationStore from "../../store/reservationStore";
import { useEffect } from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CardActions, Checkbox, Collapse, FormControl, FormControlLabel } from "@mui/material";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';



interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(0deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const CardExpand = (props: any) => {
  const storeData: any = reservationStore();
  const [expanded, setExpanded] = React.useState(false);

  useEffect(() => {
  }, []);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // 체크박스 선택검사 항목 체크 개수 제한, 선택/추가 항목 비용 계산
  function choiceInjectionCount(name: any, max: any, price: any, e: any) {
    const isChecked = e.target.checked;
    props.handleCheckedBoxes(isChecked, props.index, name)
    // if (isChecked) {
    //   storeData.setReservationInfo('addPrice', storeData.reservationInfo.addPrice + Number(price));
    // } else {
    //   storeData.setReservationInfo('addPrice', storeData.reservationInfo.addPrice - Number(price));
    // }
  }



  return (
    <Box sx={{ mb: 2 }}>
      <Accordion key={props.index} >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">
            {props.choice.title}
          </Typography>
          <Typography component="span" sx={{
            ml: '5px',
            fontSize: 14,
            color: '#ef0000'
          }}>
            {props.choice.title !== '추가' ? '(택' + props.choice.count + ')' : '(선택 시 추가 비용 발생)'}
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <FormControl component="fieldset" sx={{ width: '100%', '& .choiceBox:last-child':{borderBottom:0} }}>
            {props.injectionData.filter((item: any) => item.ipClass === props.choice.title).map((injection: any, index: any) => (

              <React.Fragment>
                <Box sx={{borderBottom:'1px dotted #ddd'}} className='choiceBox'>
                <Stack direction={'row'}>
                  <FormControlLabel required
                    control={<Checkbox style={{ pointerEvents: "auto" }}
                      icon={<CheckCircleOutlineIcon sx={{}} />}
                      checkedIcon={<CheckCircleIcon sx={{ color: '#ef8322' }} />}
                      disabled={
                        (props.checkedBoxes[props.index].length >= props.choice.count
                          && !props.checkedBoxes[props.index].some((item: any) => item.ipCode === injection.ipCode)
                          && injection.ipClass !== '추가')
                        ||
                        (storeData.closeItems.some((item: any) => item.item.code === injection.ipCode))
                          // ||
                          // (props.closeEndoscopeItems.some((item: any)=> item === injection.ipCode))

                      }
                      checked={props.checkedBoxes[props.index].some((item: any) => item.ipCode === injection.ipCode)}
                      onChange={choiceInjectionCount.bind(undefined, injection, props.choice.count, injection.price)}
                    />}
                    label={injection.inspection}
                    sx={{
                      width: 'auto',
                      '& .MuiFormControlLabel-label': { fontSize: 14, fontWeight:700 }
                    }}
                  />
                  <Typography sx={{display:'flex', alignItems:'center', ml:'auto', width: 'auto', fontSize:14, fontWeight:700}}>{injection.price.toLocaleString('ko-KR') + '원'}</Typography>
                </Stack>

                
                  <Typography variant="body2" component="div" sx={{pl:4, color:'#555', }}>{injection.memo}</Typography>
                  <Typography variant="body2" component="div" sx={{ color: '#ef0000', pl:4 }}>
                    {(storeData.closeItems.some((item: any) => item.item.code === injection.ipCode)) ?
                      storeData.reservationInfo.date.split('-')[1] + '월' + storeData.reservationInfo.date.split('-')[2] + '일 마감' : ''}
                  </Typography>
                </Box>
                
              </React.Fragment>
            ))}
          </FormControl>
        </AccordionDetails>
      </Accordion>






    </Box>
  );
}

export default CardExpand;